<script setup>
import Button from 'next/button/Button.vue';

defineProps({
  customApp: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="font-medium break-words text-n-slate-12">
        {{ customApp.name }}
      </div>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="font-medium break-words text-n-slate-12">
        {{ customApp.url }}
      </div>
    </td>
    <td class="py-4 min-w-xs">
      <div class="flex justify-end gap-1">
        <Button
          icon="i-lucide-pen"
          slate
          xs
          faded
          @click="emit('edit', customApp)"
        />
        <Button
          icon="i-lucide-trash-2"
          xs
          ruby
          faded
          @click="emit('delete', customApp, index)"
        />
      </div>
    </td>
  </tr>
</template>
